var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeatherPointed1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1382_6331)",
    filter: "url(#filter0_f_1382_6331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.29112 10.4146C8.14408 6.84029 13.7782 3.95176 16.2062 2.95544C16.5825 4.59661 17.0827 7.76554 16.9014 10.7703L14.4866 12.4182L14.6378 12.8948L16.7557 12.223C16.6711 12.8039 16.5542 13.3655 16.3982 13.8969L13.4872 15.8824L13.6384 16.359L15.6163 15.7317C14.2911 17.9519 11.5534 19.9152 8.95669 19.3356L7.74945 21.6692L7.40367 22.3362L6.07265 21.6437L6.41842 20.9767L11.4638 11.2394L10.5888 10.7858L10.359 11.2292L6.78936 18.115C4.93293 16.1794 5.10735 12.6981 6.29112 10.4146Z",
    fill: "#111111",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1382_6331",
    x: -1.04492,
    y: 0.955688,
    width: 24.0879,
    height: 24.0886,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_1382_6331"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1382_6331"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.955078 7.79297) rotate(-17.5976)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatherPointed1);
export default __webpack_public_path__ + "static/media/feather-pointed 1.33161ddb8a0a8e6fa71a4a243cba98eb.svg";
export { ForwardRef as ReactComponent };